import React, { useCallback, useEffect, useMemo, useState } from "react";
import ReactDOM from "react-dom";
import { Checkbox, message, Modal } from "antd";
import { lang } from "../../context";
import ImService from "@/server/ImService";
import { FocusSDK, getUser, isFocusEnv } from "@/utils";
import { getAppVersion } from "@/utils/getVersion";
import "./index.less";
import BatchDownloadController from "../../components/BatchDownloadPanel/BatchDownloadController";
import events from "../../context/events";
import IconFont from "@/components/icon";
import folderPng from "@/assets/img/folder.png";
import { debounce } from "lodash";
import api from "../../api";
import { downLoadFile, isChatPage } from "@/utils/chat/index";
import { analysisLog } from "@/utils/logAnalytics";
const { confirm } = Modal;
import md5 from "js-md5";
import GroupSpaceDownloadController from "../../components/GroupDownloadPanel/BatchDownloadController";
import { useHistory } from "react-router-dom";
let checked = false;
const Download = (props: any) => {
  const { newList = [], onCloseEle, from = "", type } = props;
  const [isShowConfirm, setShowConfirm] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  console.log(type, "Downloadtype");
  const DownloadService =
    type === "GROUP" || isChatPage()
      ? GroupSpaceDownloadController.getInstance()
      : BatchDownloadController.getInstance();
  const [filePath, setFilePath] = useState(DownloadService.getPath());
  const isWeb = FocusSDK.getDeviceInfo().platform === "web";
  const [userKey, setUserKey] = useState<string>("");
  const version = getAppVersion(FocusSDK);

  const doAnalysisLog = useCallback(
    (id: string, ...res: any[]) => {
      analysisLog("xtbg_jzb_joyspace_home_1676548210761", id, from || "", ...res);
    },
    [from]
  );
  useEffect(() => {
    getUser().then((res) => {
      if (res) {
        const { userId, teamUserInfo } = res;
        setUserKey(md5(userId + teamUserInfo.teamId));
      }
    });
  }, []);

  const downloadFile = useCallback(async () => {
    const data = newList[0];
    const res = await api.file.download(data.id);
    if (res.code !== "200") {
      message.error(res.status);
    }
    if (res?.data?.link) {
      downLoadFile(data.title, res.data.link);
    }
    events.emit("list.check");
  }, [newList]);
  // 读取缓存
  useEffect(() => {
    if (!userKey) {
      return;
    }
    if (isWeb) {
      const isShowJoyspaceGuide = localStorage.getItem("isShowJoyspaceTips-" + userKey);
      if (isShowJoyspaceGuide && Array.isArray(newList)) {
        downloadFile();
        return;
      }
      setShowConfirm(true);
    } else {
      const imService = ImService.getInstance();
      imService?.isAppUpgraded(version, "joyspaceTips").then((res: any) => {
        setShowConfirm(res);
        setModalVisible(!res);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newList, version, userKey]);

  // 设置缓存
  const setAppVersion = useCallback(async () => {
    if (isWeb) {
      localStorage.setItem("isShowJoyspaceTips-" + userKey, "true");
    } else {
      const imService = ImService.getInstance();
      await imService?.setAppVersion(version, "joyspaceTips");
    }
  }, [isWeb, version, userKey]);
  useEffect(() => {
    isShowConfirm &&
      confirm({
        title: "您的下载操作将被记录，是否确认下载?",
        okText: "确定",
        cancelText: "取消",
        content: (
          <Checkbox
            onChange={(val) => {
              doAnalysisLog("21", String(val.target.checked));
              checked = val.target.checked;
            }}
          >
            {lang("dont_remind")}
          </Checkbox>
        ),
        async onOk() {
          checked && setAppVersion();
          if (!isFocusEnv() && Array.isArray(newList)) {
            const data = newList[0];
            const res = await api.file.download(data.id);
            if (res.code !== "200") {
              message.error(res.status);
            }
            if (res?.data?.link) {
              downLoadFile(data.title, res.data.link);
            }
            events.emit("list.check");
            return;
          }
          setModalVisible(true);
          doAnalysisLog("19");
          // let pageList: any = Array.from(propsData);
          // events.emit('batchDownload:addTaskList', pageList);
        },
        onCancel() {
          checked = false;
          doAnalysisLog("20");
          onCloseEle();
        }
      });
  }, [isShowConfirm, newList, onCloseEle, setAppVersion, doAnalysisLog]);
  return (
    <Modal
      className="download-modal"
      width={416}
      visible={modalVisible}
      closable={false}
      cancelText="取消"
      okText="下载"
      okType="primary"
      onCancel={() => {
        doAnalysisLog("23");
        checked = false;
        setModalVisible(false);
        onCloseEle();
      }}
      onOk={debounce(() => {
        setModalVisible(false);
        doAnalysisLog("24");
        // console.log(history, '路径');
        type === "GROUP" || isChatPage()
          ? events.emit("handleGroupDownload:addTaskList", newList)
          : events.emit("handleDownload:addTaskList", newList);
        events.emit("list.check");
      }, 400)}
    >
      <h3 className="download-title">下载{newList.length}个文件</h3>
      <div
        className="download-content"
        onClick={() => {
          DownloadService.chooseDownloadPage((path: any) => setFilePath(path));
        }}
      >
        <span className="download-filePath-left">下载到</span>
        <div className="download-filePath-right">
          <img src={folderPng} />
          <span>{filePath}</span>
          <IconFont type="iconwin_right" />
        </div>
      </div>
    </Modal>
  );
};

export function downloadModal(props: any) {
  const ele = document.createElement("div");
  document.body.appendChild(ele);
  function onCloseEle() {
    if (ele) {
      ReactDOM.unmountComponentAtNode(ele);
      ele.remove();
    }
  }
  ReactDOM.render(<Download {...{ ...props, onCloseEle }} />, ele);
}
